import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  Stack,
} from "@mui/material";
import {
  dialogTitleStyle,
} from "../../styles/MUI-style-constants.js";
import "../../styles/generate-captions.scss";
import "../../styles/global.scss";

const TokensExceededMessage = (props) => {
  const handleClose = () => {
    props.setShowTokenCountExceeded(false);
  };

  const handleContinue = () => {
    handleClose();
    window.open("https://app.cloudcampaign.com/signup", "_blank");
  };

  return (
    <div>
      <Dialog open={props.open} onClose={handleClose}>
        <DialogTitle style={dialogTitleStyle}>
          {
            "You have exceeded your caption generation for the month. Check out SocialSuite, our social media scheduling tool, for access to unlimited caption generation."
          }
        </DialogTitle>
        <Stack direction="row" justifyContent="space-evenly" margin={2}>
          <Button variant="contained" color="cc" onClick={handleContinue}>
            Start Free Trial
          </Button>
        </Stack>
      </Dialog>
    </div>
  );
};

export default TokensExceededMessage;
